<template>

  <main class="page-wrapper">
    <article>
      <h1 class="page-header mb-4">Privateco</h1>

      <p>
        Kiam vi registriĝas ĉe 7 Literoj ni minimume kolektas <b>vian retpoŝtadreson</b>,
        kaj <b>uzantnomon</b> (kiun vi kreos por la apo) por identigi vin kaj teni
        viajn registraĵojn pri la ludo.

        Se vi loke registriĝas, ni bezonos ke vi elektu <b>pasvorton</b>.
        Se vi registriĝas per Google, ni ankaŭ kolektos <b>vian
        nomon</b> kaj <b>profilbildon</b>.
      </p>

      <p>
        Ni uzas nuban platformon, kiu nomiĝas Firebase, kiu apartenas al Google. Firebase
        estas uzata por kelkaj servoj ĝi provizas sed aparte por registrado de uzantoj. Do, kiam vi
        registriĝas ĉe 7 literoj, la baza informo pri vi, nome retpoŝtadreso, pasvorto kaj URL de
        via profilbildo
        estas rekte senditaj al Firebase kaj konservataj tie. Nia servilo ankaŭ konservas
        la tuton de tiu informo krom la pasvorto.
      </p>

      <p>
        Ni ankaŭ uzas retan platformon kiu nomiĝas Sentry.
        Kiam okazas eraro en la aplikaĵo, informo pri la eraro estas sendita al Sentry
        por ke ni povu ekkonscii pri ĝi, kaj poste ripari ĝin.
      </p>

      <p>
        Ludontoj eblas vidi nur vian uzantnomon kaj profilbildon, kaj nenion alian el la informo
        kiun ni kolektas.
      </p>

      <p>
        La apo utiligas kuketojn por ke la servilo rememoru pri vi. La kuketo estas kreata de Firebase
        platformo kaj uzata kiel ponto
        inter Firebase kaj nia servilo. La kuketo ne estos uzata alimaniere.
      </p>

      <p>
        En la servilo ni tenas informon pri viaj ludoj. Eblas babili kun la kontraŭulo en la apo,
        kaj ni ankaŭ konservas viajn babilojn en la servilo por ke ili ne malaperu inter viaj ensalutoj
        kaj trans aparatoj.
      </p>

      <p>
        Finitaj malnovaj ludoj kaj babiloj ligitaj al ili estos forigitaj de nia servilo kiam ni
        decidas ke ne estos utile havi ilin.
      </p>

      <p>
        Ni povas kolekti kaj konservi <b>vian IP-adreson</b> por juraj kialoj kaj por senerarigi
        aŭ plibonigi la
        programaron. Ni ankaŭ povas kolekti informon pri <b>via aparato</b> kaj <b>retumilo</b>
        kiu kurigas la
        aplikaĵon por esplori problemojn aŭ plibonigi la programaron.
      </p>

      <p>
        <strong>Ni neniam dividos aŭ diskonigos viajn nomon, retpoŝtadreson,
        pasvorton, nek vian IP-adreson kaj alian informon
        kun iu ajn sen forigonte identigeblan informon.</strong>
        Petoj farotaj de ŝtataj oficistoj por juraj kialoj estas esceptoj.

        Ni mem ne uzos ilin por iu ajn celo krom tiuj, kiuj priskribitaj ĉi tie.
        Ni povas diskonigi ludojn (sed ne historion el babilejoj sen via permeso) anonime,
        t.e. seniginte vian identigeblan datumon.
      </p>

      <p>
        <strong>Ni neniam sendos al vi retmesaĝon, kiun vi ne atendas.</strong>
        Via retpoŝtadreso estos uzata nur okaze
        ke vi forgesus vian pasvorton aŭ se vi persone kontaktus nin. Ankaŭ ni mem ne uzos vian privatan
        datumon por celoj kiuj ne rilatas al la funkciado de la aplikaĵo.
      </p>

      <p>
        Ĉiu komunikado inter la apo, nia servilo kaj Firebase estas ĉifrita.
        Nia servilo havas TLS (SSL) atestilon kaj ne akceptas neĉifritan komunikadon.
      </p>

      <p>
        Eblo forigi vian konton ekzistas. Se vi forigas vian konton, ĉiuj viaj datumoj
        <strong>krom via uzantnomo</strong> estos forviŝitaj
        de nia servilo kaj de Firebase. Ni tamen konervas vian uzantnomon
        por ke iu alia (aŭ vi) ne kreu novan konton kun la sama uzantnomo.
      </p>

      <p>
        Ebleco aŭtomate elŝuti vian datumon ne ekzistas nuntempe.
        Por peti pri tio aŭ pli da informo pri via konto bonvolu
        skribi al ni per retpoŝto ĉe
        <a href="mailto:egemadra@gmail.com">egemadra@gmail.com</a>.
      </p>

      <hr class="mb-4" />

      <p>Al la <router-link :to="{name: 'account'}">konta paĝo</router-link>.</p>

    </article>

  </main>

</template>

<style scoped>
  article p {
    @apply mb-4;
  }
</style>